var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.nodes),function(node,index){return _c('li',{key:index,staticClass:"navbar-item"},[_c('click-dropdown',{attrs:{"node":node}},[_vm._t("default")],2)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }